
import { supabase } from "@/integrations/supabase/client";

/**
 * Vérifie l'email d'un signataire de la charte et envoie l'email officiel
 */
export const verifyCharterSignatory = async (signatoryId: string, verificationToken: string) => {
  console.log('[DEBUG verifyCharterSignatory] Vérification de l\'email avec token:', { signatoryId, verificationToken });
  
  try {
// Appel de l'Edge Function (service role) pour vérifier sans RLS
    const { data: verificationResult, error: invokeError } = await supabase.functions.invoke('verify-charter-signatory', {
      body: { id: signatoryId, token: verificationToken }
    });

    if (invokeError) {
      console.error('[DEBUG verifyCharterSignatory] Erreur invoke:', invokeError);
      throw new Error('Impossible de vérifier votre email. Veuillez réessayer plus tard.');
    }

    if (!verificationResult || verificationResult.success !== true) {
      console.error('[DEBUG verifyCharterSignatory] Lien invalide ou déjà utilisé');
      throw new Error('Lien de vérification invalide ou déjà utilisé.');
    }

    if (verificationResult.alreadyVerified) {
      console.log('[DEBUG verifyCharterSignatory] La signature a déjà été vérifiée');
      return {
        success: true,
        alreadyVerified: true,
        redirectUrl: '/'
      };
    }

    console.log('[DEBUG verifyCharterSignatory] Vérification réussie:', verificationResult);
    
    console.log('[DEBUG verifyCharterSignatory] Vérification réussie, tentative d\'envoi de l\'email officiel');
    
    // Obtenir le nombre total de signatures pour le compteur
    const { data: countData } = await supabase
      .rpc('get_charter_signatures_count');
    
    const signatureCount = countData as number || 0;
    
    // Les informations nécessaires pour l'email proviennent de l'Edge Function (firstName, lastName, email)
    
    // Tentative d'envoi de l'email officiel avec le compteur via la fonction Edge
    try {
      const url = "https://jqswmyqzmjdstetjqzvv.supabase.co/functions/v1/send-charter-confirmation";
      const apiKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impxc3dteXF6bWpkc3RldGpxenZ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyMzE2NTYsImV4cCI6MjA1MjgwNzY1Nn0.JLDD0eYGJ0G_8IL5BUR7NI6iEOQyNSMIxz4PLwSO0G4";
      
console.log('[DEBUG verifyCharterSignatory] Données avant envoi:', {
        firstName: verificationResult.firstName,
        lastName: verificationResult.lastName,
        email: verificationResult.email,
        signatoryId: signatoryId,
        signatureCount: signatureCount,
        signatureNumber: verificationResult.signatureNumber
      });
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiKey}`
        },
body: JSON.stringify({
          firstName: verificationResult.firstName,
          lastName: verificationResult.lastName,
          email: verificationResult.email,
          signatoryId: signatoryId,
          signatureCount: signatureCount,
          signatureNumber: verificationResult.signatureNumber
        }),
      });
      
      const emailResult = await response.json().catch(() => ({ success: false }));
      console.log('[DEBUG verifyCharterSignatory] Réponse de la fonction d\'envoi d\'email officiel:', emailResult);
      
      return { 
        success: true, 
        signatureCount: signatureCount,
signatureNumber: verificationResult.signatureNumber,
        emailSent: response.ok,
        emailVerified: true,
        redirectUrl: '/'
      };
    } catch (emailError) {
      console.error('[DEBUG verifyCharterSignatory] Erreur attrapée lors de l\'envoi de l\'email officiel:', emailError);
      
      // Malgré l'erreur d'envoi d'email, la vérification a réussi
      return { 
        success: true, 
        signatureCount: signatureCount,
        signatureNumber: verificationResult.signatureNumber,
        emailError: true,
        emailVerified: true,
        redirectUrl: '/' 
      };
    }
  } catch (error) {
    console.error('[DEBUG verifyCharterSignatory] Erreur attrapée:', error);
    throw error;
  }
}
